import React from "react";
import styled from "@emotion/styled";

import { IconKey } from "../../../lib/icons/untitled_ui/UIcon";
import Collapsible from "../../ui/collapsible/Collapsible";
import { AllEntities, getEntityLabel } from "../utils";

type Props = {
  children: React.ReactNode;
  entity: AllEntities;
  entityCount: number;
};

const ICON_MAP: Record<AllEntities, IconKey> = {
  notice: "file06",
  document: "box",
  framework: "grid01",
  supplier: "trophy01",
  buyer: "building08",
  custom_buyer: "building08",
  contact: "userCircle",
  contact_cognism: "userCircle",
  buyer_activity_report: "presentationChart02",
};

export default function EntitySavedRow({ children, entity, entityCount }: Props) {
  return (
    <Collapsible
      key={entity}
      title={`${getEntityLabel(entity)} (${entityCount})`}
      icon={ICON_MAP[entity]}
      defaultOpen
    >
      <Content>{children}</Content>
    </Collapsible>
  );
}

const Content = styled.div({
  marginTop: 24,
});
